// edit-work-report.js
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Form, Col, Alert } from 'react-bootstrap';
import { MdAddchart } from 'react-icons/md';
import { FaAddressCard} from 'react-icons/fa';
import JoditEditor from 'jodit-react';
import './add-report.css';
import axios from 'axios';

export default function MyEditWorkReport() {
    const { reportId } = useParams();
    const [startDate, setStartDate] = useState('');
    const [endDate] = useState(new Date());
    const [report, setReport] = useState('');
    const [isFormValid, setIsFormValid] = useState(true);
    const [fetchError, setFetchError] = useState(null);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertVariant, setAlertVariant] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const navigate = useNavigate();
    const editor = useRef(null);
    const username = localStorage.getItem('name');

    // Convert ISO date to "yyyy-MM-dd" format for input display
    const formatDateForInput = (isoDate) => {
        const date = new Date(isoDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Fetch the report when the component mounts
    useEffect(() => {
        const fetchReport = async () => {
            try {
                const response = await axios.get(`https://backend.ems.hiradentallab.com/api/reports/reports/report/${reportId}`);
                const reportData = response.data;

                // Format start date for input
                setStartDate(formatDateForInput(reportData.reportingDate));
                setReport(reportData.report || '');
            } catch (error) {
                setFetchError('Error fetching report.');
                console.error('Error fetching report:', error);
            }
        };

        fetchReport();
    }, [reportId]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (!startDate || !endDate || !report.trim()) {
            setIsFormValid(false);
            return;
        }

        setIsFormValid(true);

        try {
            await axios.put(`https://backend.ems.hiradentallab.com/api/reports/reports/${reportId}`, {
                reportingDate: startDate,
                reportingTime: endDate.toLocaleTimeString(),
                report,
            });

            setAlertMessage('Report updated successfully!');
            setAlertVariant('success');
            setShowAlert(true);
            setTimeout(() => {
                navigate('/my-work-reports');
            }, 3000); // Redirect to the work report page after 3 seconds
        } catch (error) {
            console.error('Error updating report:', error);
            setAlertMessage('Error updating report.');
            setAlertVariant('danger');
            setShowAlert(true);

            setTimeout(() => {
                setShowAlert(false); // Hide the alert after 3 seconds
            }, 3000);
        }
    };

    const config = {
        // JoditEditor configuration can go here if needed
    };

    return (
        <div className='container-fluid'>
        <div className='add-report-container'>
            <div className="main-box-upper">
                <h1 className="title">
                    Edit Report
                </h1>
                <hr />
            </div>
            <h1 className="subtitle">
            <FaAddressCard className="icons" />
                {username ? `${username}'s Work reports` : 'Welcome, Guest!'}
            </h1>
            <hr />
            <div className="form-container">
                <Form onSubmit={handleFormSubmit}>
                    <div className="form-box">
                        
                {!isFormValid && (
                    <Alert variant="danger" className="mt-3">
                        Please fill out all required fields.
                    </Alert>
                )}
                {fetchError && (
                    <Alert variant="danger" className="mt-3">
                        {fetchError}
                    </Alert>
                )}
                {showAlert && (
                    <Alert variant={alertVariant} className="mt-3">
                        {alertMessage}
                    </Alert>
                )}
                        <Col md={6}>
                            <Form.Group controlId="start_date">
                                <Form.Label>Start date <span className="required">*</span> :</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="start_date"
                                    required
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    className='date-picker'
                                />
                            </Form.Group>
                        </Col>
                        <div className="mb-3">
                            <Form.Group controlId="reportEditor">
                                <Form.Label>Report:</Form.Label>
                                <JoditEditor
                                    ref={editor}
                                    value={report}
                                    config={config}
                                    tabIndex={1}
                                    onBlur={(newContent) => setReport(newContent)}
                                    className="editor"
                                />
                            </Form.Group>
                        </div>
                    </div>

                    <div className="form-actions">
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={!startDate || !endDate || !report.trim()}
                        >
                            <MdAddchart className="icon" />
                            Update
                        </Button>
                    </div>
                </Form>

            </div>
        </div>
        </div>
    );
}
